import type { Product } from '@/types';

export interface InterruptionItem {
  type: 'interruption';
  key: string;
  /** 'plinth' (image above text, default) | 'overlay' (text over a full-bleed image). */
  variant?: string | null;
  eyebrow?: string | null;
  message: string;
  subText?: string | null;
  image?: { mainSrc: string | null; altText: string | null } | null;
  cta?: { text: string; url: string } | null;
  /** Whole-card link; used even when the CTA button is hidden. */
  link?: string | null;
  /** 'cta-olive' | 'cta-lime' | 'cta-white' | 'cta-black' — drives the CTA colour tokens. */
  ctaColour?: string | null;
}

export type RailItem = Product | InterruptionItem;

export const isInterruption = (item: RailItem): item is InterruptionItem =>
  (item as InterruptionItem).type === 'interruption';
